export default {
  table_ordering: 'Comandă la masă',
  table: 'Masă',
  pickup_or_delivery: 'Ridicare sau livrare',
  asap: 'Cât mai curând',
  served_in: 'Servit în {{time}} min',
  not_taking_orders: 'Nu preia comenzi',
  not_your_table: 'Nu e masa ta? Scanează codul de la masa ta.',
  eating_here: {
    title: 'Mănânci aici?',
    back_to_table: 'Comandă pentru {{table}}. Ți-o aducem noi.',
    scan_code: 'Scanează codul QR de pe masă pentru a comanda la masă.',
  },
  notes: {
    table_unavailable: {
      title: 'Codul QR al acestei mese nu mai funcționează.',
      text: 'Te rugăm să întrebi personalul. Încă poți comanda pentru ridicare.',
      text_no_pickup: 'Te rugăm să întrebi personalul.',
    },
    table_ordering_off: {
      title: 'Comanda la masă nu este disponibilă acum.',
      text: 'Poți comanda pentru ridicare.',
    },
    load_failed: {
      title: 'Nu am putut încărca masa ta.',
      text: 'Scanează din nou codul QR.',
    },
    closed: {
      title: 'Închis acum.',
      text: 'Poți comanda la masă de la {{time}}.',
      text_later: 'Poți comanda la masă după ce deschidem din nou.',
    },
    paused: {
      title: 'Nu preluăm comenzi acum.',
      text: 'Te rugăm să întrebi personalul sau să încerci din nou peste câteva minute.',
    },
  },
  cart: {
    closed: 'Închis acum. Poți comanda la masă de la {{time}}. Coșul tău este păstrat până atunci.',
    closed_later: 'Închis acum. Coșul tău este păstrat până deschidem din nou.',
    paused: 'Nu preluăm comenzi acum. Coșul tău este păstrat. Te rugăm să întrebi personalul.',
  },
  cash_note: 'Plătești numerar la tejghea.',
  confirmation: {
    bring_to_table: 'Îți aducem comanda la masă.',
    your_table: 'Masa ta',
    moved_table: 'Te-ai mutat la altă masă? Spune-i personalului numărul comenzii tale <strong>{{number}}</strong>.',
  },
  served: 'Servit',
};
